import { createFileRoute } from "@tanstack/react-router";
import { ProgramPartnerskiListPage } from "@/features/sys-premiowy/program-partnerski-list-page";
import { ensureElementVisible } from "@/lib/route-guards";

export const Route = createFileRoute("/_auth/raporty/system-premiowy/program-partnerski/")({
	component: ProgramPartnerskiListPage,
	beforeLoad: async ({ context, location }) => {
		await ensureElementVisible(
			context.queryClient,
			"sidebar.raporty.sys-premiowy-program-partnerski",
			location.pathname,
		);
	},
});
